const media = {
    mobilenav: window.matchMedia('only screen and (max-width: 1007px)'),
    fullnav: window.matchMedia('only screen and (min-width: 1008px)')
}

export default media